import { render, staticRenderFns } from "./productGrouping.vue?vue&type=template&id=52e22fda&scoped=true&"
import script from "./productGrouping.vue?vue&type=script&lang=js&"
export * from "./productGrouping.vue?vue&type=script&lang=js&"
import style0 from "./productGrouping.vue?vue&type=style&index=0&id=52e22fda&scoped=true&lang=scss&"
import style1 from "./productGrouping.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e22fda",
  null
  
)

export default component.exports